import type { UseQueryOptions } from 'react-query'

export const CHURN_SURVEY_TYPEFORM_LIVE_ID = '01KS3F2CHR68SBG0M1VF6HQKSZ'

/** Keeps hidden-field query data stable for the Typeform embed session. */
export const CHURN_SURVEY_STABLE_QUERY_OPTIONS: Pick<
  UseQueryOptions,
  'refetchOnMount' | 'refetchOnWindowFocus' | 'refetchOnReconnect'
> = {
  refetchOnMount: false,
  refetchOnWindowFocus: false,
  refetchOnReconnect: false,
}
